// extracted by mini-css-extract-plugin
export default {"SPICellContainer":"SPICell_SPICellContainer__u9yKF","green":"SPICell_green__icB9x","red":"SPICell_red__l+SE5","orange":"SPICell_orange__+Qqk4"};